import { useQuery } from "@tanstack/react-query";
import { IApiPagination } from "../../../interfaces/IPagination";
import distributorSpecialPriceApi from "../services/distributorSpecialPrice.api";
import { DistributorSpecialPriceFilterType } from "..";

export type UseDistributorSpecialPriceQueryParams = {
  filter: DistributorSpecialPriceFilterType;
  pagination: IApiPagination;
};

export const useDistributorSpecialPriceQuery = (
  params: UseDistributorSpecialPriceQueryParams,
) => {
  return useQuery({
    queryKey: ["distributor-special-prices", params],
    queryFn: async () => {
      const res = await distributorSpecialPriceApi.getDistributorSpecialPrices(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useDistributorSpecialPriceByIdQuery = (id: string) => {
  return useQuery({
    queryKey: ["distributor-special-price", id],
    queryFn: () =>
      distributorSpecialPriceApi.getDistributorSpecialPriceById(id),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!id,
  });
};
